import { styled } from '@mui/material/styles';

// default useStyles --------------------------------------------------------

export const ManageSelectedContainer = styled('div')({});

export const ManageSelectedText = styled('div')(({ theme }) => ({
  fontSize: 13,
  fontWeight: 'bold',
  fontStyle: 'italic',
  padding: theme.spacing(2),
}));

export const ManageButtonContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: theme.spacing(1),

  '& button': {
    backgroundColor: theme.palette.secondary.main,
    marginRight: theme.spacing(1),
    color: theme.palette.common.white,

    '&:first-child': {
      backgroundColor: theme.palette.common.black,
    },

    '&.accessButton': {
      backgroundColor: theme.palette.secondary.main,
    },
  },
}));

export const ManageFormContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: '0 auto',

  '& .MuiInputBase-root': {
    width: '100%',
  },
  '& .MuiFormGroup-root': {
    backgroundColor: theme.palette.action.disabled,
    width: '85%',
    marginTop: theme.spacing(3),
    padding: `0 ${theme.spacing(1)}`,
  },
}));

export const ManageModalContent = styled('div')(({ theme }) => ({
  padding: theme.spacing(4),
}));

export const ManageModalTitle = styled('div')(({ theme }) => ({
  fontWeight: 'bold',
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
}));

export const ManageNameRow = styled('div')(({ theme }) => ({
  margin: theme.spacing(2),
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
}));

export const ManageCenterLoader = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  flexGrow: 1,
  alignItems: 'center',
  justifyContent: 'center',
});

export const ManageBarTitle = styled('div')({
  textAlign: 'center',
  width: '100%',
});

export const ManageTitle = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
});

export const ManageProfileContainer = styled('div')({
  position: 'relative',
  top: 64,
});

export const ManageDefaultXsHide = styled('span')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));
